<!--个人中心-->
<template v-if ="isUseOem">
  <div class="oem">
    <el-form
      :model="oemForm"
      ref="oemForm"
      :rules="oemRules"
      :label-position="labelPosition"
      class="chang_oem"
    >
      <el-form-item
        label="OEM信息"
        label-width="800px"
        class="chang_title"
      ></el-form-item>
      <el-form-item
        label="公司简称"
        prop="company_name_s"
        label-width="200px"
        label-height="40px"
      >
        <el-input
          v-model="oemForm.company_name_s"
          type="text"
          auto-complete="off"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item
        label="公司全名"
        prop="company_name"
        label-width="200px"
        label-height="40px"
      >
        <el-input
          v-model="oemForm.company_name"
          type="text"
          auto-complete="off"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item
        label="公司网址"
        prop="username"
        label-width="200px"
        label-height="40px"
      >
        <el-input
          v-model="oemForm.company_website"
          type="text"
          auto-complete="off"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item
        class="textareaLbl"
        label="公司简介"
        prop="company_info"
        label-width="200px"
        label-height="40px"
      >
        <el-input
          v-model="oemForm.company_info"
          type="textarea"
          auto-complete="off"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="产品支持电话" prop="company_phone" label-width="200px">
        <el-input
          v-model="oemForm.company_phone"
          type="text"
          auto-complete="off"
          placeholder=""
          clearable
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="产品支持Email" prop="email" label-width="200px">
        <el-input
          v-model="oemForm.email"
          type="text"
          auto-complete="off"
          placeholder="请填写正确的邮件地址"
          clearable
        ></el-input>
      </el-form-item> -->
      <el-form-item
        label="产品中文名称"
        prop="name"
        label-width="200px"
        label-height="40px"
      >
        <el-input
          v-model="oemForm.name"
          type="text"
          auto-complete="off"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item
        label="产品英文名称"
        prop="name_s"
        label-width="200px"
        label-height="40px"
      >
        <el-input
          v-model="oemForm.name_s"
          type="text"
          auto-complete="off"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item
        label="帮助中心名字"
        prop="username"
        label-width="200px"
        label-height="40px"
      >
        <el-input
          v-model="oemForm.help_name"
          type="text"
          auto-complete="off"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item
        label="帮助中心对应网址"
        prop="username"
        label-width="200px"
        label-height="40px"
      >
        <el-input
          v-model="oemForm.help_website"
          type="text"
          auto-complete="off"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item class="upload_lbl" label="icon图标" label-width="200px" label-height="40px">
        <div class="upload_box">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleLogoSuccess"
            :multiple="false"
            :before-upload="beforeLogoUpload"
          >
            <img v-if="oemForm.logo_ico ==''" :src="logoIconUrl" class="avatar" />
            <img v-else :src="oemForm.logo_ico" class="avatar" />
          </el-upload>
          <span>（*注：大小为64*64，格式为ico格式）</span>
        </div>
      </el-form-item>
      <el-form-item class="upload_lbl" label="app图标" label-width="200px" label-height="40px">
        <div class="upload_box">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleAppImgSuccess"
            :multiple="false"
            :before-upload="beforeAppImgUpload"
          >
            <img v-if="oemForm.logo_png ==''" :src="appImgUrl" class="avatar" />
            <img v-else :src="oemForm.logo_png" class="avatar" />
            <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
          </el-upload>
          <span>（*注：大小为128*128，格式为png格式）</span>
        </div>
      </el-form-item>
      <el-form-item
        label="路由器名称"
        prop="username"
        label-width="200px"
        label-height="40px"
      >
        <el-input
          v-model="oemForm.dr_name"
          type="text"
          auto-complete="off"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item class="upload_lbl" label="路由器图标" label-width="200px" label-height="40px">
        <div class="upload_box">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleDRlogoSuccess"
            :multiple="false"
            :before-upload="beforeAppImgUpload"
          >
            <img v-if="oemForm.dr_logo ==''" :src="drlogoUrl" class="avatar" />
            <img v-else :src="oemForm.dr_logo" class="avatar" />
            <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
          </el-upload>
          <span>（*注：大小为128*128，格式为png格式）</span>
        </div>
      </el-form-item>
      <div class="btn_group">
        <!-- <el-button
          class="primary submit_oem"
          :loading="loading"
          >提交信息</el-button
        > -->
        <el-button @click="submitOemInfo()" class="primary submit_oem" :loading="loading"
          >提交</el-button
        >
      </div>
    </el-form>

    <el-form :label-position="labelPosition" class="chang_oem">
      <el-form-item
        label="OEM"
        label-width="800px"
        class="chang_title"
      ></el-form-item>
      <el-form-item
        label="下载链接"
        prop="download"
        label-width="200px"
        label-height="40px"
      >
        <div class="link_box">
          <span v-if="oemURL ==''">无</span>
          <span v-else><a :href="oemURL">{{oemURL}}</a></span>
        </div>
      </el-form-item>
      <div class="btn_group">
        <el-button @click="createOemUrlClick()" class="primary submit_oem" :loading="loading"
          >生成OEM</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import { isvalidPhone } from "@/assets/js/validate";
import { updateOemInfo, oem, check_oem } from "@/api/user";
import { getToken } from '@/utils/auth'
export default {
  data() {
    return {
      loading: false,
      logoIconUrl: "",
      appImgUrl: "",
      isUseOem:false,
      isOem:false,
      oemURL:"",
      uploadUrl:process.env.VUE_APP_BASE_API+"/attachement/",
      uploadHeaders:{
        Authorization:"token "+ getToken()
      },
      runTime:null,
      labelPosition: "left",
      username: "tizdata",
      changePwdVisible: false,
      formLabelWidth: "120px",
      oemForm: {
        company_name_s: "天智鲲鹏",
        company_name : "北京天智鲲鹏科技有限公司",
        company_website:"http://www.tizdata.com/",
        company_info: "北京天智鲲鹏科技有限公司致力于帮助中小企业的管理人员，不受时间、空间的限制，迅速准确的获取企业经营状况，及时准确的作出决策。",
        company_phone:"010-85866619",
        // email: "Service@tianzhi.com",
        name:"天智BI",
        name_s:"FastBI",
        help_name:"帮助中心",
        help_website:"https://help.tizdata.com/",
        logo_ico:"",
        logo_png:""
      },
      oemRules: {
        company_name_s: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
        ],
        company_name: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
        ],
        company_website: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
        ],
        company_info: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
        ],
        company_phone: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur",
          },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
        ],
        name_s: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
          { pattern: /^[A-Za-z]+$/, message: '只能输入英文' }
          
        ],
        help_name: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
        ],
        help_website: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
        ]
      }
    };
  },
  mounted() {
    this.getUserInfo()
    this.logoIconUrl = window.location.origin + "/static/img/favicon.ico"
    this.appImgUrl = window.location.origin + "/static/img/logo.png"
    this.drlogoUrl = window.location.origin + "/static/img/dr_logo.png"
  },
  methods: {
    createOemUrlClick(){
      this.oemURL = ""
      this.$message.info("开始生成OEM,请稍等一段时间。")
      oem().then(res=>{
        this.$parent.loading = true
        this.$parent.loadingText = "正在打包..."
        this.timeoutRunstatus(res)
      }).catch(()=>{
      })
    },
    timeoutRunstatus(obj){
      clearTimeout(this.runTime)
      if(obj.status == 3){
        this.$message.error("OEM打包出错，请重试！")
        this.$parent.loading = false
        this.$parent.loadingText = ""
        return
      }
      if(obj.url.length !=0){
        this.oemURL = obj.url
        this.$parent.loading = false
        this.$parent.loadingText = ""
        return
      }
      this.runTime = setTimeout(()=>{
        check_oem(obj.rid).then(res=>{
          this.timeoutRunstatus(res)
        }).catch(error=>{
          this.$message.error(error)
        })
      },2000)
    },
    getUserInfo(){
      const { agent_info, oem_info}  = this.$store.getters.userInfo
      if(agent_info){
        this.isUseOem = agent_info.allow_oem
      }else{
        this.isUseOem = false
      }
      if(oem_info){
        this.oemForm = oem_info
        this.isOem = true 
      }else{
        this.isOem = false
      }
      console.log('dadada',agent_info, oem_info);
    },
    async submitOemInfo(){
      this.$refs["oemForm"].validate(valid => {
        if (valid) {
          this.$parent.loading = true
          updateOemInfo(this.oemForm).then(async()=>{
            this.$message.success("提交OEM信息成功")
            await this.$store.dispatch("user/userinfo")
            this.getUserInfo()
            this.$parent.loading = false
          }).catch(()=>{
            this.$parent.loading = false
          })
        } else {
          return false;
        }
      });
    },
    handleLogoSuccess(res, file) {
      this.$message.success('ICON图标上传成功')
      this.oemForm.logo_ico = res.file
    },
    beforeLogoUpload(file) {
      const isICON = file.type === "image/x-icon";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isICON) {
        this.$message.error("上传icon图标只能是 ICO 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传大小不能超过 2MB!");
      }
      return isICON && isLt2M;
    },
    handleAppImgSuccess(res, file) {
      this.$message.success('APP图标上传成功')
      this.oemForm.logo_png = res.file
    },
    handleDRlogoSuccess(res, file) {
      this.$message.success('路由器图标上传成功')
      this.oemForm.dr_logo = res.file
    },
    beforeAppImgUpload(file) {
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isPNG) {
        this.$message.error("上传图片只能是 PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isPNG && isLt2M;
    }
  },
};    
</script>

<style lang='scss'>
.chang_oem {
  /*margin: auto;*/
  margin-top: 31px;
  margin-left: 41px;
  width: 800px;
}

.chang_title .el-form-item__label {
  font-size: 14px !important;
  background-color: #d3e4f4 !important;
}

.chang_oem .el-form-item__label {
  padding-left: 35px;
  line-height: 38px;
  background-color: #f9f9f9;
  border: 1px solid #dcdfe6;
  font-size: 12px;
}
.chang_oem {
  .link_box,.upload_box {
    //width: 100%;
    height: 100%;
    line-height: 38px;
    text-align: center;
    border: 1px solid #dcdfe6;
  }
  .upload_box{
    text-align: left;
    line-height: 1;
    padding: 5px;
  }
  .upload_lbl{
    .el-form-item__label {
      line-height: 92px;
    }
  }
  .textareaLbl {
    .el-form-item__label {
      line-height: 52px;
    }
    .el-textarea__inner {
      border-radius: 0;
      font-size: 12px;
      height: 54px;
    }
  }
}
.chang_oem .el-form-item {
  margin-bottom: 0px;
}

.chang_oem .el-form-item .el-form-item__content {
  line-height: normal;
}

.chang_oem .el-form-item.is-success .el-input__inner,
.chang_oem .el-form-item.is-error .el-input__inner {
  border-color: #dcdfe6;
}

.chang_oem .el-input__inner {
  border-radius: 0px;
}

.chang_oem .el-input {
  font-size: 12px;
}

.select_industry {
  width: 600px;
}

.select_address {
  width: 600px;
}

.chang_oem .el-form-item__error {
  position: inherit;
  height: 20px;
  line-height: 20px;
  padding-top: 0px;
  padding-bottom: 5px;
}

/*.submit_main {
		margin: auto;
		margin-right: 0px;
	}*/

.submit_oem {
  margin-top: 47px !important;
  //margin-left: 697px !important;
  padding: 0px !important;
  width: 103px !important;
  height: 34px !important;
  /*line-height: 34px;*/
  background-color: #3887cc;
  border-radius: 2px;
  border: solid 1px #e5e5e5;
}

.submit_oem span {
  /*line-height: 34px;*/
}
.oemCenter {
  .btn_group {
    text-align: right;
  }
  .submit_oem {
    margin-left: 10px;
  }
}
.oem {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 64px;
    height: 64px;
    line-height: 64px;
    text-align: center;
  }
  .avatar {
    width: 64px;
    height: 64px;
    display: block;
  }
  .logo{
    line-height: 64px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/my/OEM.vue